import { computed, ref, watch } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { result as _result } from 'lodash-es'
import { useApi } from '@/composables/api'
import { useUserStore } from '@/stores/user'
import { i18n } from '@/i18n'
import { dropdownLabel } from '@/lib/dropdownLabel.js'

export const useConfigsStore = defineStore('configs', () => {
  const { refresh, model: config } = useApi({ url: 'config', data: {}, pick: d => d })
  const isApiOk = ref(false)
  const { isAuthorized } = storeToRefs(useUserStore())

  const get = (pth, def = null) => computed(() => _result({ ...config.value }, pth, def))

  const getById = (pth, id, def) =>
    computed(() => {
      const locale = i18n.global.locale.value
      const c = _result(config.value, pth, [])
      for (const dd of c) {
        if (dd.id == id) {
          return dropdownLabel(dd, locale)
        }
      }
      return def
    })

  watch(
    isApiOk,
    async (now, prev) => {
      if (now && !prev && isAuthorized.value) {
        await refresh()
      }
    },
    { immediate: true }
  )

  return {
    config,
    get,
    getById,
    isApiOk,

    fill: refresh,
  }
})
